export const MAP_JOB_COLORS: Record<string, { bg: string; text: string }> = {
  CANCELED: { bg: '#D94444', text: '#FFFFFF' },
  CANCELLED: { bg: '#D94444', text: '#FFFFFF' },
  CHECKING_OUT: { bg: '#FFE066', text: '#2C2E30' },
  CHECKOUT: { bg: '#FFE066', text: '#2C2E30' },
  CREATED: { bg: '#ADB5BD', text: '#2C2E30' },
  DELIVERED: { bg: '#2B8A3E', text: '#FFFFFF' },
  DELIVERING: { bg: '#37B24D', text: '#FFFFFF' },
  EXECUTION_DONE: { bg: '#2B8A3E', text: '#FFFFFF' },
  FINISHED: { bg: '#2B8A3E', text: '#FFFFFF' },
  GOING_TO_DESTINATION: { bg: '#3ACF3A', text: '#FFFFFF' },
  GOING_TO_ORIGIN: { bg: '#FFC078', text: '#2C2E30' },
  IN_ROUTE: { bg: '#3ACF3A', text: '#FFFFFF' },
  PICKING: { bg: '#FD7E14', text: '#2C2E30' },
  READY_FOR_PICKUP: { bg: '#66A80F', text: '#FFFFFF' },
  STORED: { bg: '#F59F00', text: '#2C2E30' },
  STORING: { bg: '#F59F00', text: '#2C2E30' },
  TRANSFERRING: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_FROM: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_FROM_PICKING_TO_STORAGE: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO_STORAGE_FROM_PICKING: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_FROM_STORAGE_TO_DELIVERY: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO_DELIVERY_FROM_STORAGE: { bg: '#FCC419', text: '#2C2E30' }
}
